export const LAST_MEALS_PAGE_KEY = 'lastMealsPage';

export const MEAL_TYPES = ['breakfast', 'lunch', 'dinner'];
export const MEAL_TYPE_LABELS = {
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
};
